import moment from "moment";
import React, { useEffect, useState } from "react";
import { CustomerContactsState } from "src/types";

import LineChart from "../generic/LineChart";
import * as helpers from "./helpers";

interface Props {
  customerContacts: CustomerContactsState;
}

const CustomersWithNbaChart: React.FC<Props> = ({
  customerContacts,
}: Props) => {
  const [chartData, setChartData] = useState<Array<{ x: string; y1: number }>>(
    []
  );
  const [xTicks, setXTicks] = useState<string[]>([]);
  useEffect(() => {
    setChartData(
      customerContacts.countPerInterval.map((intervalCounts) => ({
        x: intervalCounts.date,
        y1:
          intervalCounts.count > 0
            ? parseFloat(
                (
                  (100 * intervalCounts.countWithNba) /
                  intervalCounts.count
                ).toFixed(1)
              )
            : 0,
      }))
    );
  }, [customerContacts]);

  useEffect(() => {
    if (chartData.length > 0) {
      setXTicks(helpers.getXDateTicks(chartData));
    }
  }, [chartData]);

  return (
    <LineChart
      chartId="withNbaChart"
      data={chartData}
      height={350}
      xTickLabelsAngled
      xlabel="Monat"
      xAxisLabelOffset={35}
      xTickFormatter={(xValue) =>
        helpers.xTickFunction(xTicks, xValue as string)
      }
      tooltipXValueFormatter={(xVal) =>
        helpers.getWeekRangeStringForDate(xVal as string)
      }
      axisAllocation={{
        left: ["y1"],
      }}
      yValueFormatterAxisLeft={(tick) => `${tick} %`}
      ylabelAxisLeft="Kontakte mit Beratungsfokus"
      curveLabels={{ y1: "Kontakte mit Beratungsfokus" }}
      averageLines={["y1"]}
    />
  );
};

export default CustomersWithNbaChart;



// WEBPACK FOOTER //
// ./src/components/NbaEvaluation/CustomerContactsWithNbaChart.tsx